import { EllipsisVertical } from "lucide-react";
import { useState } from "react";

import { IgIconButton } from "@intelligems/ig-theme";
import { Menu, MenuItem } from "@mui/material";
import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { EditDemoUrlDialog } from "@src/features/experienceBuilder/toolbar/EditDemoUrlDialog";
import { useDispatch } from "@src/store";
import { ExperienceBuilderAction } from "@src/store/slices/experienceBuilder";

export const MoreMenuButton = () => {
  const dispatch = useDispatch();
  // Demo URL points the preview at a store the org doesn't own — an internal
  // tool, not a merchant-facing feature. `undefined` while loading, so this
  // stays hidden until admin status is known.
  const isAdmin = useIsAdmin();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const [editDemoUrlOpen, setEditDemoUrlOpen] = useState(false);

  const handleClose = () => setAnchorEl(null);

  const handleEditCssJs = () => {
    handleClose();
    void dispatch(ExperienceBuilderAction.basicMod.selectInjection());
  };

  const handleEditDemoUrl = () => {
    handleClose();
    setEditDemoUrlOpen(true);
  };

  return (
    <>
      <IgIconButton
        onClick={(e) => setAnchorEl(e.currentTarget)}
        aria-label="More options"
      >
        <EllipsisVertical size={16} />
      </IgIconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleEditCssJs} sx={{ fontSize: 12 }}>
          Edit CSS/JS
        </MenuItem>
        {isAdmin && (
          <MenuItem onClick={handleEditDemoUrl} sx={{ fontSize: 12 }}>
            Edit demo URL
          </MenuItem>
        )}
      </Menu>
      {isAdmin && (
        <EditDemoUrlDialog
          open={editDemoUrlOpen}
          onClose={() => setEditDemoUrlOpen(false)}
        />
      )}
    </>
  );
};
